module.exports = __webpack_public_path__ + "img/brand--plaza-vea1.377d6fc8.jpg";